import { useScrollAnim } from "../../hook/useScrollAnim";
import imgCarte from "../../../assets/img/projects/Maison_Marline/MM-carte.png";
import imgDeven from "../../../assets/img/projects/Maison_Marline/MM-deventure.png";

export default function App() {
  const containerRef = useScrollAnim({
    selector: ".MM-palette > div, .MM-ImagePres img",
    threshold: 0.3,
    once: true,
  });

  return (
    <div className="MM-identity" ref={containerRef}>
      <div className="MM-palette">
        <div className="c1" />
        <div className="c2" />
        <div className="c3" />
        <div className="c4" />
      </div>

      <div className="MM-ImagePres">
        <img src={imgDeven} alt="Deventure" />
        <img src={imgCarte} alt="Carte" />
      </div>
    </div>
  );
}
